import { productsTab } from "./products-tab";
import { categories } from "./categories";

export const products = {
	tabs: {
		productsTab,
		categories,
		generalStock: "Stock General",
	},
	functions: {
		modal: {
			sheet: {
				inventory: "inventario",
				columns: {
					id: "Id del producto",
					name: "Nombre",
					category: "Categoría",
					type: "Tipo de producto",
					hasAlcohol: "¿Contiene alcohol?",
					fiscalCode: "SKU",
					fiscalNcm: "Fiscal - NCM",
				},
			},
		},
	},
	emptyList: "Ningún producto encontrado",
};
